<template lang="pug">
.main
  div.d-flex.mt-4.align-center
    v-img.mt-2.ml-2(:src="require('@/assets/images/logo_main.png')" max-height="40" max-width="100" contain)
    v-spacer

  v-layout(style="height:90vh")
    v-container.white.lighten-4.my-auto(style="max-width: 600px;" :class="{'mx-0 px-0': this.$vuetify.breakpoint.xs}")
      v-card.pa-6.rounded-xl(outlined :tile="$vuetify.breakpoint.xs" :class="{'px-8': !$vuetify.breakpoint.xs}")
        div.d-flex.justify-center.my-6(v-if="isFetching")
          v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
        v-form(v-else ref="form")
          h5.text-center.primary--text(v-if="company") Log in to {{ company.name }}
          v-text-field.text-sm.font-normal.mt-6.round-xl(v-model="username" placeholder="Enter username" outlined dense height="48" hide-details :rules="rules.not_empty" @keyup.enter="signIn")
          v-text-field.text-sm.mt-6.round-xl(v-model="password" placeholder="Password" outlined dense height="48" :type="passwordType" hide-details :rules="rules.not_empty" @keyup.enter="signIn")
            template(#append)
              v-btn(icon small style="margin-top: 2px;" @click="changePasswordType(passwordType)")
                v-icon(color="neutral500") {{ passwordType === 'text' ? 'mdi-eye-off' : 'mdi-eye' }}
          v-btn.mt-6.mb-3.font-weight-bold.button-AA-medium.white--text(color="info500" x-large block depressed @click="signIn" :loading="isLoading" height="40") {{ $t('log_in') }}
      div.d-flex.justify-center.align-center.mt-4
        v-btn.text-xs.text-none(color="neutral500" text small @click="$router.push('/signin')") Sign in with email instead
        
</template>

<script>
import Cookies from 'js-cookie'
import { mapActions } from 'vuex'

export default {
  name: 'SignInClinic',
  data: () => ({
    isFetching: false,
    isLoading: false,
    company: null,
    loading: false,
    username: null,
    password: null,
    passwordType: 'password',
    rules: {
      not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
    },
  }),
  mounted () {
    this.init()
  },
  methods: {
    ...mapActions(['showMessage', 'updateCompany']),
    init () {
      this.isFetching = true
      let slug = localStorage.getItem('yz_login_company') || null
      if (this.$route?.query?.slug) {
        slug = this.$route.query.slug
      }
      if (slug) {
        this.fetchCompany(slug)
      } else {
        this.$router.push('/signin')
      }
    },
    fetchCompany (slug) {
      this.$axios.get(`/clinics/${slug}`)
        .then(resp => {
          if (resp.data) {
            this.company = resp.data.company
          }
        })
        .catch(() => {
          this.$router.push('/signin')
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchGenes (company) {
      this.$axios.get(`/companies/${company.id}/genes`)
        .then((response) => {
          this.$store.commit('subscriptions/setLimitations', response.data)
          this.$store.commit('subscriptions/setGenes', response.data)
        })
        .catch(() => {})
    },
    changePasswordType (type) {
      if (type === 'text') {
        this.passwordType = 'password'
      } else {
        this.passwordType = 'text'
      }
    },
    signIn () {
      if (!this.$refs.form.validate()) {
        this.showMessage(['error', 'Please enter username and password'])
        return
      }
      this.isLoading = true
      const payload = {
        company: this.company.id,
        username: this.username,
        password: this.password
      }
      this.$axios.post(`/members/token`, payload)
        .then(resp => {
          this.completeSignIn(resp.data, 'username')
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.length > 0) {
            message = err.response.data[0]
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    completeSignIn (respData, signInMethod = null) {
      const user = { ...respData.user, token: respData.token }
      this.$store.commit('user/setUser', user)
      this.$axios.defaults.headers.common['Authorization'] = `Token ${respData.token}`
      if (signInMethod) {
        this.$logEvent('user.signed_in', { method: signInMethod })
      }
      this.launch(this.company)
    },
    launch (company) {
      let nextPath = '/admin/dashboard'
      let cookieNextPath = Cookies.get('yz_next_path')
      if (cookieNextPath) {
        nextPath = cookieNextPath
        this.$store.commit('ui/setRedirectPath', null)
      }
      localStorage.setItem('yz_login_company', company.slug)
      this.$axios.get(`/companies/${company.id}/`)
        .then(resp => {
          const data = resp.data
          this.updateCompany(data)
          this.fetchGenes(data)
          this.$router.push(nextPath)
        })
        .catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>